Vue.component('contactform', {
  data() {
    return {
        hasFurniture: null,
        contactReason: "",
        contactReasonText: "",
        };
    },
    methods: {

        setContactReasonText(text) {
            this.contactReasonText = text;
        }

    }

});
